import { formatINR } from "../lib/api";

function buildUpiIntent({ upi, name, amount, ref }) {
  const params = new URLSearchParams({
    pa: upi,
    pn: name,
    am: String(Number(amount).toFixed(2)),
    cu: "INR",
    tn: `LC-${ref || ""}`,
  });
  return `upi://pay?${params.toString()}`;
}

export function UpiPayCard({ upi, name, amount, ref, testid = "upi-pay-card" }) {
  const intent = buildUpiIntent({ upi, name, amount, ref });
  const qr = `https://api.qrserver.com/v1/create-qr-code/?size=280x280&margin=8&data=${encodeURIComponent(
    intent,
  )}`;
  return (
    <div
      data-testid={testid}
      className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm"
    >
      <div className="flex items-center gap-2">
        <span className="grid h-8 w-8 place-items-center rounded-lg bg-green-100 font-bold text-green-800">
          ₹
        </span>
        <div>
          <p className="font-display text-base font-semibold text-stone-900">
            Pay {formatINR(amount)} · UPI
          </p>
          <p className="text-[11px] text-stone-500">
            Scan the QR from any UPI app (GPay, PhonePe, Paytm) or tap the button on mobile.
          </p>
        </div>
      </div>

      <div className="mt-4 grid gap-4 sm:grid-cols-[220px_1fr] sm:items-center">
        <div className="mx-auto rounded-xl border border-stone-200 bg-white p-2">
          <img
            src={qr}
            alt="UPI QR"
            width={220}
            height={220}
            className="h-[220px] w-[220px]"
          />
        </div>
        <div className="space-y-3">
          <div className="rounded-xl bg-stone-50 p-3 text-xs">
            <p className="text-stone-500">UPI ID</p>
            <p className="font-mono text-sm font-semibold text-stone-900">{upi}</p>
          </div>
          <a
            data-testid={`${testid}-open-app`}
            href={intent}
            className="block w-full rounded-full bg-green-600 py-3 text-center text-sm font-semibold text-white hover:bg-green-700"
          >
            Open UPI app to pay
          </a>
          <button
            type="button"
            data-testid={`${testid}-copy`}
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(upi);
              } catch (err) {
                console.debug("clipboard write failed", err);
              }
            }}
            className="w-full rounded-full border border-stone-300 py-2 text-xs font-semibold text-stone-700 hover:bg-stone-50"
          >
            Copy UPI ID
          </button>
          <p className="text-[11px] text-stone-500">
            After paying, confirm with our team on WhatsApp. Your order will be dispatched
            immediately.
          </p>
        </div>
      </div>
    </div>
  );
}
